namespace RioERP.Products {
    export interface ProductTeacherShareRow {
        Id?: number;
        ProductId?: number;
        TeacherId?: number;
        ESharingType?: SharingType;
        SharingAmount?: number;
        IsActive?: boolean;
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        TeacherName?: string;
        TeacherDescription?: string;
        TeacherEmail?: string;
        TeacherAlternateEmail?: string;
        TeacherMobile?: string;
        TeacherAlternateMobile?: string;
        TeacherAddress?: string;
        TeacherCity?: string;
        TeacherStateId?: number;
        TeacherUserId?: number;
        TeacherGstin?: string;
        TeacherPan?: string;
        TeacherGstCertificate?: string;
        TeacherBankName?: string;
        TeacherBankAccountType?: number;
        TeacherBankAccountName?: string;
        TeacherBankAccountNo?: string;
        TeacherBankIfscCode?: string;
        TeacherPincode?: number;
        TeacherIsActive?: boolean;
        TeacherInsertUserId?: number;
        TeacherInsertDate?: string;
        TeacherUpdateUserId?: number;
        TeacherUpdateDate?: string;
        RowIds?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductTeacherShareRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Products.ProductTeacherShare';
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ProductId = "ProductId",
            TeacherId = "TeacherId",
            ESharingType = "ESharingType",
            SharingAmount = "SharingAmount",
            IsActive = "IsActive",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            TeacherName = "TeacherName",
            TeacherDescription = "TeacherDescription",
            TeacherEmail = "TeacherEmail",
            TeacherAlternateEmail = "TeacherAlternateEmail",
            TeacherMobile = "TeacherMobile",
            TeacherAlternateMobile = "TeacherAlternateMobile",
            TeacherAddress = "TeacherAddress",
            TeacherCity = "TeacherCity",
            TeacherStateId = "TeacherStateId",
            TeacherUserId = "TeacherUserId",
            TeacherGstin = "TeacherGstin",
            TeacherPan = "TeacherPan",
            TeacherGstCertificate = "TeacherGstCertificate",
            TeacherBankName = "TeacherBankName",
            TeacherBankAccountType = "TeacherBankAccountType",
            TeacherBankAccountName = "TeacherBankAccountName",
            TeacherBankAccountNo = "TeacherBankAccountNo",
            TeacherBankIfscCode = "TeacherBankIfscCode",
            TeacherPincode = "TeacherPincode",
            TeacherIsActive = "TeacherIsActive",
            TeacherInsertUserId = "TeacherInsertUserId",
            TeacherInsertDate = "TeacherInsertDate",
            TeacherUpdateUserId = "TeacherUpdateUserId",
            TeacherUpdateDate = "TeacherUpdateDate",
            RowIds = "RowIds",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
